import React, { Component } from "react";
import { Segment, Statistic, Divider, Header } from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";

class NetworkStatistics extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      statistics: [],
      availabilityData: {},
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "networkStatistics", { mode: "cors", signal: this.state.controller.signal })
        .then(res => res.json())
        .then(data => data)
        .catch(() => "")
    );

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "graphicNetworkStatus", { mode: "cors", signal: this.state.controller.signal })
        .then(res => res.json())
        .then(data => data)
        .catch(() => "")
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    if (resolvedPromisses[0] !== "" && resolvedPromisses[1] !== "") {
      this.setState({
        statistics: resolvedPromisses[0].networkStatistics,
        availabilityData: resolvedPromisses[1]
      }, () => {
        this.setAvailabilityData();
      });
    }
  }

  getNetworkFaultsStatistic = () => {
    let statisticValue = "";
    let statisticLabel = "";

    if (this.state.statistics.failures < 100000) {
      statisticValue = this.state.statistics.failures;
    }
    else if (this.state.statistics.failures >= 100000 && this.state.statistics.failures < 1000000) {
      statisticValue = Math.floor(this.state.statistics.failures / 1000).toString();
      statisticLabel = <p>{Strings.THOUSAND}</p>;
    }
    else if (this.state.statistics.failures >= 1000000 && this.state.statistics.failures < 1000000000) {
      statisticValue = Math.floor(this.state.statistics.failures / 1000000);

      if (this.state.statistics.failures >= 1000000 && this.state.statistics.failures < 2000000) {
        statisticLabel = <p>{Strings.MILLION_OF}</p>;
      }
      else {
        statisticLabel = <p>{Strings.MILLIONS_OF}</p>;
      }
    }
    else {
      statisticValue = Math.floor(this.state.statistics.failures / 1000000000);

      if (this.state.statistics.failures >= 1000000000 && this.state.statistics.failures < 2000000000) {
        statisticLabel = <p>{Strings.BILLION_OF}</p>;
      }
      else {
        statisticLabel = <p>{Strings.BILLIONS_OF}</p>;
      }

    }

    if (isNaN(statisticValue)) {
      return (
        <Statistic size="large">
          <Statistic.Value></Statistic.Value>
          <Statistic.Label>{statisticLabel}{Strings.FAULTS_STRING}</Statistic.Label>
        </Statistic>
      ); 
    } else {
      return (
        <Statistic size="large">
          <Statistic.Value>{statisticValue.toString()}</Statistic.Value>
          <Statistic.Label>{statisticLabel}{Strings.FAULTS_STRING}</Statistic.Label>
        </Statistic>
      );
    }
  }

  getNetworkRetriesStatistic = () => {
    let statisticValue = "";
    let statisticLabel = "";

    if (this.state.statistics.retries < 100000) {
      statisticValue = this.state.statistics.retries;
    }
    else if (this.state.statistics.retries >= 100000 && this.state.statistics.retries < 1000000) {
      statisticValue = Math.floor(this.state.statistics.retries / 1000).toString();
      statisticLabel = <p>{Strings.THOUSAND}</p>;
    }
    else if (this.state.statistics.retries >= 1000000 && this.state.statistics.retries < 1000000000) {
      statisticValue = Math.floor(this.state.statistics.retries / 1000000);

      if (this.state.statistics.retries >= 1000000 && this.state.statistics.retries < 2000000) {
        statisticLabel = <p>{Strings.MILLION_OF}</p>;
      }
      else {
        statisticLabel = <p>{Strings.MILLIONS_OF}</p>;
      }
    }
    else {
      statisticValue = Math.floor(this.state.statistics.retries / 1000000000);

      if (this.state.statistics.retries >= 1000000000 && this.state.statistics.retries < 2000000000) {
        statisticLabel = <p>{Strings.BILLION_OF}</p>;
      }
      else {
        statisticLabel = <p>{Strings.BILLIONS_OF}</p>;
      }
    }

    if (isNaN(statisticValue)) {
      return (
        <Statistic size="large">
          <Statistic.Value></Statistic.Value>
          <Statistic.Label>{statisticLabel}{Strings.RETRIES_STRING}</Statistic.Label>
        </Statistic>
      );
    } else {
      return (
        <Statistic size="large">
          <Statistic.Value>{statisticValue.toString()}</Statistic.Value>
          <Statistic.Label>{statisticLabel}{Strings.RETRIES_STRING}</Statistic.Label>
        </Statistic>
      );
    }
  }

  getNetworkDiagnosticsStatistic = () => {
    let statisticValue = "";
    let statisticLabel = "";

    if (this.state.statistics.diagnostics < 100000) {
      statisticValue = this.state.statistics.diagnostics;
    }
    else if (this.state.statistics.diagnostics >= 100000 && this.state.statistics.diagnostics < 1000000) {
      statisticValue = Math.floor(this.state.statistics.diagnostics / 1000).toString();
      statisticLabel = <p>{Strings.THOUSAND}</p>;
    }
    else if (this.state.statistics.diagnostics >= 1000000 && this.state.statistics.diagnostics < 1000000000) {
      statisticValue = Math.floor(this.state.statistics.diagnostics / 1000000);

      if (this.state.statistics.diagnostics >= 1000000 && this.state.statistics.diagnostics < 2000000) {
        statisticLabel = <p>{Strings.MILLION_OF}</p>;
      }
      else {
        statisticLabel = <p>{Strings.MILLIONS_OF}</p>;
      }

    }
    else {
      statisticValue = Math.floor(this.state.statistics.diagnostics / 1000000000);

      if (this.state.statistics.diagnostics >= 1000000000 && this.state.statistics.diagnostics < 2000000000) {
        statisticLabel = <p>{Strings.BILLION_OF}</p>;
      }
      else {
        statisticLabel = <p>{Strings.BILLIONS_OF}</p>;
      }
    }

    if (isNaN(statisticValue)) {
      return (
        <Statistic size="large">
          <Statistic.Value></Statistic.Value>
          <Statistic.Label>{statisticLabel}{Strings.DIAGNOSTICS_STRING}</Statistic.Label>
        </Statistic>
      );
    } else {
      return (
        <Statistic size="large">
          <Statistic.Value>{statisticValue.toString()}</Statistic.Value>
          <Statistic.Label>{statisticLabel}{Strings.DIAGNOSTICS_STRING}</Statistic.Label>
        </Statistic>
      );
    }
  }

  // The network availabilty is calculated this way:
  // Percentage of time the network was on OK status + percentage of the time the network was on DIAGNOSTIC status
  setAvailabilityData = () => {
    let availability = this.state.availabilityData.percentageAvailable + this.state.availabilityData.percentageDiagnostic;
    document.getElementById("network-availability").innerHTML = availability.toFixed(0).concat("%");
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  render() {
    return (
      <Segment style={segmentStyle}>

        <Header as='h3' textAlign="center" color="teal">
          {Strings.STATISTICS}
        </Header>
        <Divider style={{ marginTop: "-8px" }} />

        <Statistic.Group widths={4} size="small">
          {this.getNetworkFaultsStatistic()}
          {this.getNetworkRetriesStatistic()}
          {this.getNetworkDiagnosticsStatistic()}
          <Statistic>
            <Statistic.Value id="network-availability"></Statistic.Value>
            <Statistic.Label>{Strings.AVAILABILITY}</Statistic.Label>
          </Statistic>
        </Statistic.Group>

      </Segment>
    );
  }
}

const segmentStyle = {
  textAlign: "center",
  marginBottom: "4vh"
};

export default NetworkStatistics;